var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.galleryPriceList.length > 0)?_c('div',{staticClass:"dash-preview"},[_c('ModalPriceList',{attrs:{"price-list":_vm.galleryPriceList,"currency":_vm.data.currency,"is-demo":_vm.data.isDemo,"event-name":_vm.data.event_name,"is-preview":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }